module.exports = __webpack_public_path__ + "img/connectia.403da98d.svg";